import { Vestiging } from "@/entities/vestiging";
import { useState } from "react";
import { VestigingenUpdateHandler } from "../../shared";
import { LokaleVestigingenSection } from "./lokale-vestiging-section";
import { NsRetailVestigingenSection } from "./ns-retail-vestiging-section.tsx";

interface OpenAanvragenKlantenserviceProps {
    vestigingen: Vestiging[];
    onVestigingenUpdate: VestigingenUpdateHandler;
}

export function OpenAanvragenKlantenservice({ vestigingen, onVestigingenUpdate }: Readonly<OpenAanvragenKlantenserviceProps>) {
    const [localToelichtingChanges, setLocalToelichtingChanges] = useState<Record<number, string>>({}); // for nsRetailVestigingen, the toelichting is kept in local state and sent to the BE when all vestigingen are approved.

    const nsRetailVestigingen = vestigingen
        .filter((v) => v.beheerVestiging.isNsRetailVestiging)
        .map((v) => ({
            ...v,
            aangevraagdeVestiging: {
                ...v.aangevraagdeVestiging!,
                toelichtingKlantenservice: localToelichtingChanges[v.aangevraagdeVestiging!.id]
                    ? localToelichtingChanges[v.aangevraagdeVestiging!.id]
                    : v.aangevraagdeVestiging?.toelichtingKlantenservice,
            },
        }));

    const lokaleVestigingen = vestigingen.filter((v) => !v.beheerVestiging.isNsRetailVestiging);

    const nsRetailVestigingenByStation = Vestiging.groupByStation(nsRetailVestigingen);
    const lokaleVestigingenByStation = Vestiging.groupByStation(lokaleVestigingen);

    const counts = {
        nsRetailVestigingStartRequests: nsRetailVestigingen.filter((v) => v.aangevraagdeVestiging.status === "Besteld").length,
        nsRetailVestigingStopRequests: nsRetailVestigingen.filter((v) => v.aangevraagdeVestiging.status === "StopAangevraagd").length,
        lokaleVestigingRequests: lokaleVestigingen.length,
    };

    return (
        <div className="space-y-6">
            <div className="space-y-6">
                {counts.nsRetailVestigingStartRequests > 0 && (
                    <NsRetailVestigingenSection
                        variant="start"
                        nsRetailVestigingenByStation={nsRetailVestigingenByStation}
                        onVestigingenUpdate={onVestigingenUpdate}
                        onToelichtingChange={setLocalToelichtingChanges}
                    />
                )}
                {counts.nsRetailVestigingStopRequests > 0 && (
                    <NsRetailVestigingenSection
                        variant="stop"
                        nsRetailVestigingenByStation={nsRetailVestigingenByStation}
                        onVestigingenUpdate={onVestigingenUpdate}
                        onToelichtingChange={setLocalToelichtingChanges}
                    />
                )}
                {counts.lokaleVestigingRequests > 0 && (
                    <LokaleVestigingenSection
                        lokaleVestigingenByStation={lokaleVestigingenByStation}
                        onVestigingUpdate={onVestigingenUpdate}
                    />
                )}
            </div>
        </div>
    );
}
